import { ErrorDialog } from '@/components/shared'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

export const ErrorDetailModal = NiceModal.create(({ error, message }: any) => {
   const modal = useModal()
   return <ErrorDialog error={error} isOpen={modal.visible} message={message} onCancel={modal.hide} onClose={() => modal.hide()} />
})
